import {
  CardActions,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Switch,
  Box,
  FormControlLabel,
  TextField,
  CircularProgress,
  Backdrop,
  MobileStepper,
  Typography,
  Paper,
  IconButton
} from '@material-ui/core';
import moment from 'moment';
import { red } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { GetLocation } from 'src/utils/Common';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Autocomplete from '@material-ui/lab/Autocomplete';
import HelpIcon from '@material-ui/icons/Help';
import axios from 'src/utils/axios';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import CloseIcon from '@material-ui/icons/Close';
import { setTask } from '../../store/actions/taskActions';
import RepeatOneIcon from '@material-ui/icons/RepeatOne';
import SearchBar from 'material-ui-search-bar';
import { sc } from 'src/utils/Common';
import { getUser } from 'src/utils/Common';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import {
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  resetDefects,
  resetLabours,
  resetMaterials,
  getTasksRequest
} from '../../store/actions';
import UrunSearch from '../../components/Selects/ProductSearch';
import { Row } from '@material-ui/data-grid';

const useStyles = makeStyles(theme => ({
  root: {},
  avatar: {
    backgroundColor: red[500]
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  cardsMax: {
    maxHeight: 300,
    minHeight: 300
  },
  cardsMaxDialog: {
    maxHeight: 500,
    minHeight: 500
  },
  appBar: {
    position: 'relative'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  divider: {
    height: 28,
    margin: 4
  },
  iconButton: {
    padding: 10
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));


function Urun({
  className,
  ReceiptNo,
  readonly,
  tasks,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  resetDefects,
  resetLabours,
  resetMaterials,
  setTask,
  getTasksRequest
}) {
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [openBarkod, setOpenBarkod] = useState(false);
  const [UrunData, setUrunData] = useState({});
  const [clearBarkod, setClearBarkod] = useState(true);
  const [search, setSearch] = useState('');
  const today = new Date();
  const maxYil = today.getFullYear();
  const [searched, setSearched] = useState('');
  const [initialRows, setinitialRows] = useState('');
  const [formValid, setFormValid] = useState(true);
  const [urunTarihceAc, seturunTarihceAc] = useState(false);
  const [FLSModule, setFLSModule] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [SerialParam, setSerialParam] = React.useState('');
  const SessionUser = getUser();
  const [ProblemData, setProblemData] = useState([]);
  const [ProblemDetailData, setProblemDetailData] = useState([]);
  const [HomeWhiz, setHomeWhiz] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [Product3rdLevelHieararchy, setProduct3rdLevelHieararchy] = useState('')
  const [formState, setFormState] = useState([
    {
      name: 'SerialNumber',
      min: 0,
      max: 9999999999,
      valid: true,
      errorMessage: t('error_serino')
    },
    {
      name: 'ProductionYear',
      min: 0,
      max: maxYil,
      valid: true,
      errorMessage: t('error_uyil').replace('@maxYil', maxYil)
    },
    {
      name: 'ProductionMonth',
      max: 12,
      min: 0,
      valid: true,
      errorMessage: t('error_udonem')
    }
  ]);
  const [ProductData, setProductData] = useState({
    ProductId: 0,
    SolutionSymptomMatchingDtoList: [
      {
        Symptom: {
          Id: 1,
          Name: ''
        },
        SolutionList: [
          {
            Id: 1,
            Name: ''
          }
        ]
      }
    ]
  });
  const [
    ProductSymptomSolutionMatchingData,
    setProductSymptomSolutionMatchingData
  ] = useState();
  const [barkod, setBarkod] = useState('');
  const storeData = tasks.tasks.filter(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );
  const [expanded, setExpanded] = React.useState('panel1');

  const handleAccChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    GetLocation();
    if (storeData.length !== 0) {
      setUrunData(storeData[0]);
      setBarkod(storeData[0].Barcode);
    } else {
      setUrunData({});
    }
  }, [ReceiptNo, tasks.tasks, readonly]);

  const requestSearch = searchedVal => {
    const filteredRows = initialRows.filter(item => sc(item.Fls, searchedVal));
    setProblemData(filteredRows);
  };
  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  const handleChange = e => {
    const { name } = e.target;
    const { value } = e.target;
    let tmpValid = true;
    for (let i = 0; i < formState.length; i++) {
      const obj = formState[i];
      if (obj.name === name && value) {
        if (value > obj.max || value <= obj.min) {
          setFormState([
            ...formState.slice(0, i),
            { ...obj, valid: false },
            ...formState.slice(i + 1)
          ]);
        } else {
          setFormState([
            ...formState.slice(0, i),
            { ...obj, valid: true },
            ...formState.slice(i + 1)
          ]);
        }
      }
      tmpValid = tmpValid && obj.valid;
    }
    setFormValid(tmpValid);
    if (e.target.type === 'checkbox') {
      const value = e.target.checked ? 1 : 0;
      let job = UrunData;
      job = { ...job, [name]: value };
      setTask(job);
      setUrunData(job);
    } else {
      const obj = formState.filter(f => f.name === name)[0];
      if (parseInt(value) > obj.min && parseInt(value) <= obj.max) {
        let job = UrunData;
        job = { ...job, [name]: value };
        setTask(job);
        setUrunData(job);
      } else {
        let job = UrunData;
        job = { ...job, [name]: obj.min };
        setTask(job);
        setUrunData(job);
      }
    }
  };

  const setModel = param => {
    let job = UrunData;

    setHomeWhiz(param.HOMEWHIZ);

    if (job.ModelCode !== param.KUL_MODEL_KODU) {
      setUyari(t('product_changed_message'));
      setOpen(true);
      resetDefects();
      resetLabours();
      resetMaterials();
      getDefectRequest(param.KUL_MODEL_KODU, 1, []);
      getMaterialRequest(
        param.KUL_MODEL_KODU,
        job.WarrantyTypeId,
        1,
        UrunData.UYIL || 0,
        UrunData.UDONEM || 0,
        UrunData?.ReceiptNo || 0
      );
      getLabourRequest(param.KUL_MODEL_KODU, job.WarrantyTypeId, 1, '',ReceiptNo);
      job = { ...job, HIZMETLER: [], ISCILIKLER: [], MALZEMELER: [] };
    }
    job = {
      ...job,
      ModelCode: param.KUL_MODEL_KODU,
      Model: param.ACIKLAMA,
      HomeWhiz: param.HOMEWHIZ,
      BrandCode: param.MARKA_KODU,
      MainHierarchyId: param.MainHierarchyId,
      Barcode: '',
      SerialNumber: null,
      ProductionMonth: null,
      ProductionYear: null,
      ProductId: param.MODEL_KODU
    };

    setTask(job);
    setUrunData(job);
  };
  const handleClose = () => {
    setOpen(false);
  };
  function openFLSModule() {
    setProblemData([]);
    setProblemDetailData([]);
    setLoading(true);

    axios
      .get(`/GetProductsThirdLevelHieararchy/${storeData[0].ProductId}`)
      .then(responseX => {
        setProduct3rdLevelHieararchy(responseX.data)
        axios.get(`/GetFls/${storeData[0].ModelCode}`)
          .then(response => {
            if (response.data.length > 0) {
              setProblemData(response.data);
              setinitialRows(response.data);
            } else {
              setProblemData([]);
            }
            setLoading(false);
            setFLSModule(true);
          })
          .catch(error => {
            setLoading(false);
            setProblemData([]);
          });
      })
  }

  const handleListItemClick = (event, index, FlsId) => {
    setSelectedIndex(index);
    setLoading(true);
    axios
      .get(`/GetFlsDetail/${FlsId}`)
      .then(response => {
        if (response.data.length > 0) {
          setProblemDetailData(response.data);
          handleReset();
        } else {
          setProblemDetailData([]);
        }

        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        setProblemDetailData([]);
      });
  };

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const closeWithFls = () => {

    const updateDto = {
      WorkOrderId: storeData[0].ReceiptNo,
      EmployeeId: SessionUser.TechnicianId
    }

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    setLoading(true);
    axios
      .post('/CloseWorkOrderByFlsCompleted', updateDto, config)
      .then(response => {
        if (response.data?.ResponseCode == "200") {
          getTasksRequest(parseInt(storeData[0].ReceiptNo));
        } else {
          getTasksRequest(parseInt(storeData[0].ReceiptNo));
          setUyari(response.data?.Error);
        }
        setFLSModule(false);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  function hasOnlyDigits(value) {
    return /^-?\d+$/.test(value);
  }

  function ControlSerialNrOldWay (Sku, Barcode, BarcodeParam, SerialNr, ProductMonth, ProductYear, job) {
    axios
      .get(`/ControlSerialNumber/${Sku}/${0}/${Barcode}`)
      .then(response => {
        if(response.data){
          var serialNumberYear = calculateSerialNumberYear(response.data.ProductionYearRule, Barcode)
          var serialNumberMonth = calculateSerialNumberMonth(response.data.ProductionMonthRule, Barcode)
          var wantedSerialNumber = findOriginalSerialNumber(response.data.SerialNumberRule, Barcode)

          if (serialNumberYear != null && serialNumberMonth != null && wantedSerialNumber != null) {
            job = {
              ...job,
              Barcode: BarcodeParam,
              SerialNumber: wantedSerialNumber,
              ProductionMonth: serialNumberMonth,
              ProductionYear: serialNumberYear
            };

            setTask(job);
            setUrunData(job);
            return;
          }
        }
        else {
          if (Barcode.length === 10) {
            ProductYear = '20' + Barcode.substring(0, 2);
            SerialNr = Barcode.substring(2, 8);
            ProductMonth = Barcode.substring(8, 10);

            if (parseInt(ProductMonth) === 0 || parseInt(ProductMonth) > 12 || !hasOnlyDigits(ProductMonth)) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              setTask(job);
              setUrunData(job);
              return;
            }

            if (
              ProductYear.length !== 4 ||
              parseInt(ProductYear) > parseInt(moment().format('yyyy')) ||
              !hasOnlyDigits(ProductYear)
            ) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              setTask(job);
              setUrunData(job);
              return;
            }

            if (!hasOnlyDigits(SerialNr)) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              setTask(job);
              setUrunData(job);
              return;
            }

            job = {
              ...job,
              Barcode: BarcodeParam,
              SerialNumber: SerialNr,
              ProductionMonth: ProductMonth,
              ProductionYear: ProductYear
            };
            setTask(job);
            setUrunData(job);
            return;
          }
          if (Barcode.length === 14 || Barcode.length === 18) {
            if (Barcode.length === 14) {
              ProductYear = '202' + Barcode.substring(5, 6);
              ProductMonth = Barcode.substring(6, 8);
              SerialNr = Barcode.substring(8, 13);
              job = {
                ...job,
                Barcode: BarcodeParam,
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };

              setTask(job);
              setUrunData(job);
            }
            if (Barcode.length === 18) {

              ProductYear = '20' + Barcode.substring(6, 8);
              ProductMonth = Barcode.substring(14, 16);
              SerialNr = Barcode.substring(9, 14);
              job = {
                ...job,
                Barcode: BarcodeParam,
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };

              setTask(job);
              setUrunData(job);
            }
          }

          setSerialParam(Barcode);
          if (SessionUser.TenantId !== 78) {
            if (
              ProductYear === '' ||
              ProductMonth === '' ||
              SerialNr === '' ||
              ProductYear === undefined ||
              ProductMonth === undefined ||
              SerialNr === undefined
            ) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              setTask(job);
              setUrunData(job);
            }
            if (parseInt(ProductMonth) === 0 || parseInt(ProductMonth) > 12) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              setTask(job);
              setUrunData(job);
            }
            if (
              ProductYear.length !== 4 ||
              parseInt(ProductYear) > parseInt(moment().format('yyyy'))
            ) {
              setUyari(Barcode + '-' + t('lblInvalidSerialNr'));
              setOpen(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              job = {
                ...job,
                Barcode: '',
                SerialNumber: SerialNr,
                ProductionMonth: ProductMonth,
                ProductionYear: ProductYear
              };
              setTask(job);
              setUrunData(job);
            }
          }
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const handleChangeBarcodeParse = Barcode => {
    let job = UrunData;
    var Sku = job?.ModelCode;
    var ProductYear = '';
    var ProductMonth = '';
    var SerialNr = '';
    var BarcodeParam = Sku + Barcode;
    var ProductId = job?.ProductId;

    if (Barcode === '9900000199' || SessionUser.TenantId === 59)
    {
        setUyari(Barcode + '-' + t('lblDummySerialNrWarning'));
        setOpen(true);
    }

    setLoading(true);
    axios
      .get(`/ParseSerialNumber/${ProductId}/${Barcode}`)
      .then(response => {
        if(response.data.Response == 1 || response.data.Response == 2){ //2 added for Pakistan serial number logic
          job = {
            ...job,
            Barcode: BarcodeParam,
            SerialNumber: response.data.SerialNr,
            ProductionMonth: response.data.MonthValue,
            ProductionYear: response.data.YearValue
          };

          setTask(job);
          setUrunData(job);
          if (response.data.Response == 2 && SessionUser.TenantId === 75)
          {
              setUyari(Barcode + '-' + t('lblNoExistManactureData'));
              setOpen(true);
          }
          return;
        }
        else {
          ControlSerialNrOldWay(Sku, Barcode, BarcodeParam, SerialNr, ProductMonth, ProductYear, job)
        }
      });


    if (
      SessionUser.TenantId === 9
      || SessionUser.TenantId === 37
      || SessionUser.TenantId === 51
      || SessionUser.TenantId === 56
      || SessionUser.TenantId === 78
    ) {
      return;
    }



  };

  function calculateSerialNumberYear(yearRule, serialNumber) {
    if (yearRule == null || yearRule == undefined) {
      return null
    }
    else if (yearRule.includes(',')) {
      var tempYearRule = yearRule.split(',')
      var result = parseInt('20' + serialNumber[parseInt(tempYearRule[0]) - 1] + serialNumber[parseInt(tempYearRule[1]) - 1])
      return result
    }
    //CONSTANT
    else if (yearRule == '0') {
      var result = 1981
      return result
    }
    else {
      var year = parseInt(serialNumber[parseInt(yearRule) - 1])
      var currentYear = moment().format('yyyy')

      // Yıl Hesaplama için yılın son hanesini gelen yıl kuralının yılından çıkarıyorum
      // Eğer Kalan negatif ise mevcut yılın son hanesine 10 ekliyip yıl kuralından çıkarıp onu da Bütün yıldan çıkarıyorum 
      // örnek: 8 geldi 2'den çıkarıyorum çünkü 2022, 2 - 8 = -6
      // -6 sıfırdan küçük olduğu için 2ye 10 ekliyorum ve 12 - 8 yapıyorum sonucum 4
      // bu elimde ki 4 ise 2022 den çıkarıyorum sonuç 2018

      if (parseInt(currentYear.substring(3)) - year < 0) {
        var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) + 10 - year)
        return result
      }
      else {
        var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) - year)
        return result
      }
    }
  }

  function calculateSerialNumberMonth(monthRule, serialNumber) {
    if (monthRule == null || monthRule == undefined) {
      return null
    }
    else if (monthRule.includes(',')) {
      var tempMonthRule = monthRule.split(',')
      var result = parseInt(serialNumber[parseInt(tempMonthRule[0]) - 1] + serialNumber[parseInt(tempMonthRule[1]) - 1])
      if (parseInt(result) > 12) {
        setUyari(serialNumber + '-' + t('lblInvalidSerialNr'));
        setOpen(true);
        return null;
      }
      return result
    }
    else if (monthRule.length == 1 && monthRule != '0') {
      var tempResult = serialNumber[parseInt(monthRule)-1]
      if (Number.isInteger(+tempResult)) {
        return tempResult
      }
      else if (tempResult == 'A') {
        return 10
      }
      else if (tempResult == 'B') {
        return 11
      }
      else if (tempResult == 'C') {
        return 12
      }
    }
    //CONSTANT
    else if (monthRule == '0') {
      var result = 1
      return result
    }
    else {
      return null
    }
  }

  function findOriginalSerialNumber(serialNumberRule, serialNumber) {
    if (serialNumberRule == null || serialNumberRule == undefined) {
      return null
    }
    else if (serialNumberRule.includes(',')) {
      var tempSerialNumberRule = serialNumberRule.split(',')
      if (parseInt(tempSerialNumberRule[1]) - serialNumber.length === 1) {
        var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
        return result
      }
      else if (serialNumber.length !== parseInt(tempSerialNumberRule[1])) {
        setUyari(serialNumber + '-' + t('lblInvalidSerialNr'));
        setOpen(true);
        return null;
      }
      else {
        var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
        return result
      }
    }
    else {
      return null
    }
  }

  return (
    <>
      <Card className={classes.cardsMax}>
        <CardHeader title={`${t('lblBarkod')}:${UrunData.Barcode}`} />
        <Divider />
        <CardContent className={classes.content}>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title" color="primary">
              {t('Bilgilendirme')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {Uyari}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                {t('lblTamam')}

              </Button>
            </DialogActions>
          </Dialog>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <UrunSearch
                setModel={setModel}
                value={
                  {
                    KUL_MODEL_KODU: UrunData.ModelCode,
                    ACIKLAMA: UrunData.Model
                  } || ''
                }
                searchParam={search}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label={t('input_serino')}
                name="SerialNumber"
                size="small"
               // type="number"
                disabled
                value={UrunData.SerialNumber || ''}
                fullWidth
                required
                onChange={handleChange}
                variant="outlined"
                error={
                  !formState.filter(n => n.name === 'SerialNumber')[0].valid
                }
                helperText={
                  formState.filter(n => n.name === 'SerialNumber')[0].valid
                    ? ''
                    : formState.filter(n => n.name === 'SerialNumber')[0]
                      .errorMessage
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label={t('input_uyil')}
                name="ProductionYear"
                type="number"
                size="small"
                disabled
                value={UrunData.ProductionYear || ''}
                fullWidth
                required
                onChange={handleChange}
                variant="outlined"
                error={
                  !formState.filter(n => n.name === 'ProductionYear')[0].valid
                }
                helperText={
                  formState.filter(n => n.name === 'ProductionYear')[0].valid
                    ? ''
                    : formState.filter(n => n.name === 'ProductionYear')[0]
                      .errorMessage
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label={t('input_udonem')}
                name="ProductionMonth"
                size="small"
                disabled
                value={UrunData.ProductionMonth || ''}
                type="number"
                fullWidth
                required
                onChange={handleChange}
                variant="outlined"
                error={
                  !formState.filter(n => n.name === 'ProductionMonth')[0].valid
                }
                helperText={
                  formState.filter(n => n.name === 'ProductionMonth')[0].valid
                    ? ''
                    : formState.filter(n => n.name === 'ProductionMonth')[0]
                      .errorMessage
                }
              />
            </Grid>
            <Grid item xs={4} align="center">
              <FormControlLabel
                control={
                  <Switch
                    color="primary"
                    readOnly
                    checked={UrunData.Revision === 1 || false}
                    //onChange={handleOnCheck}
                    disabled={false}
                    name="AttributeId"
                  />
                }
                label="Rev"
              />
            </Grid>
            <Grid item xs={4} align="center">
              <Button
                disableElevation
                variant="contained"
                color="primary"
                size="small"
                endIcon={<HelpIcon>send</HelpIcon>}
                onClick={() => {
                  openFLSModule();
                }}
              >
                {t('FLS')}
              </Button>
            </Grid>
            <Grid item xs={4} align="center">
              <Button
                disabled
                variant="contained"
                color="primary"
                size="small"
                endIcon={
                  HomeWhiz ? (
                    <ThumbUpAltIcon style={{ color: 'green' }} />
                  ) : (
                    <ThumbDownAltIcon style={{ color: 'red' }} />
                  )
                }
              >
                {t('HomeWhiz')}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <div className={classes.text}>
                <TextField
                  label={t('lblSerialNr')}
                  name="Barcode"
                  size="small"
                  value={SerialParam || ''}
                  fullWidth
                  onChange={e => setSerialParam(e.target.value)}
                  variant="outlined"
                />
                <Grid item xs={1}></Grid>
                <Button
                  disableElevation
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => handleChangeBarcodeParse(SerialParam || '')}
                >
                  <RepeatOneIcon />
                </Button>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Dialog
        open={FLSModule}
        onClose={() => setFLSModule(false)}
        fullWidth
        maxWidth="lg"
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-title">{t('FLS') + ' - ' + Product3rdLevelHieararchy}</DialogTitle>
        <DialogContent>
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid container spacing={1}>
            <Grid item xs={5}>
              <Card className={classes.cardsMaxDialog}>
                <CardHeader title={t('lblProblem')} />
                <Divider />
                <br />
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} lg={12}>
                    <SearchBar
                      inputSizeSmall
                      value={searched}
                      onChange={searchVal => requestSearch(searchVal)}
                      onCancelSearch={() => cancelSearch()}
                      placeholder={t('lblSearch')}
                      style={{ margin: '0 auto', maxWidth: 600, maxHeight: 37 }}
                    />
                  </Grid>
                </Grid>
                <Card style={{ maxHeight: 400, overflow: 'auto' }}>
                  <CardContent>
                    <Paper>
                      <List component="nav" aria-label="main mailbox folders">
                        {ProblemData?.map((item, index) => (
                          <ListItem
                            button
                            key={index}
                            selected={selectedIndex === 0}
                            onClick={event =>
                              handleListItemClick(event, index, item.FlsId)
                            }
                          >
                            <ListItemText primary={item.Fls} />
                          </ListItem>
                        ))}
                      </List>
                    </Paper>
                  </CardContent>
                </Card>
              </Card>
            </Grid>
            <Grid item xs={7}>
              <Card className={classes.cardsMaxDialog}>
                <CardHeader title={t('lblOperation')} />
                <Divider />
                <CardContent style={{ maxHeight: 400, overflow: 'auto' }}>
                  <Grid container spacing={2}>
                    <Stepper activeStep={activeStep} orientation="vertical">
                      {ProblemDetailData.map((row, index) => (
                        <Step key={index}>
                          <StepLabel>{row.Question}</StepLabel>
                          <StepContent>
                            <Typography>{row.Answer}</Typography>
                            <div className={classes.actionsContainer}>
                              <div>
                                <Button
                                  disabled={activeStep === 0}
                                  onClick={handleBack}
                                  className={classes.button}
                                >
                                  {t('lblBack')}
                                </Button>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleNext}
                                  className={classes.button}
                                >
                                  {activeStep === ProblemDetailData.length - 1 ? t('lblFinish') : t('lblNext')}
                                </Button>
                              </div>
                            </div>
                          </StepContent>
                        </Step>
                      ))}
                    </Stepper>
                  </Grid>
                  {activeStep === ProblemDetailData.length && (
                    <Paper square elevation={0} className={classes.resetContainer}>
                      <Typography>{t('lblAllStepsCompleted')}</Typography>
                      <Button onClick={handleReset} className={classes.button}>
                        {t('lblReset')}
                      </Button>
                    </Paper>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
        <Button
                disableElevation
                variant="contained"
                color="primary"
                size="small"
                onClick={() => {
                  closeWithFls();
                }}
              >
                 {t('lblCloseWithFls')}
          </Button>
          <IconButton
            color="primary"
            onClick={event => setFLSModule(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

Urun.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  {
    resetLabours,
    resetDefects,
    resetMaterials,
    getDefectRequest,
    getLabourRequest,
    getMaterialRequest,
    setTask,
    getTasksRequest
  }
)(Urun);
